import ExperienceRBC from "../../views/portfolio/ExperienceRBC";
import HowDoYouChew from "../../views/portfolio/HowDoYouChew";
import ToyotaWishGiver from "../../views/portfolio/ToyotaWishGiver";
import FlavorVote from "../../views/portfolio/FlavorVote";
import BeaconMedical from "../../views/portfolio/BeaconMedical";
import Trickl from "../../views/portfolio/Trickl";
import Annex from "../../views/portfolio/Annex";
import Salus from "../../views/portfolio/Salus"

const data = [
  {
    id: 1,
    title: "eXperience RBC",
    slug: "rbc",
    thumb: '/assets/img/project/rbc/thumb.png',
    banner: '/assets/img/project/rbc/header.png',
    src: '/assets/img/project/rbc/header.png',
    category: ["Mobile"],
    type: "Large Screen Display",
    description:
      "Cal was first. The first public university in the great state of California. They are the pioneers. They are the trailblazers who started it all.",
    overlay: 1,
    component: (props) => <ExperienceRBC {...props} />,
  },

  {
    id: 2,
    title: "How Do You Chew",
    slug: "excel",
    thumb: '/assets/img/project/excel/thumb.png',
    banner: "/assets/img/project/excel/header.png",
    src: '/assets/img/project/excel/header.png',
    category: ["Web"],
    type: "Website",
    description:
      "Once the brand strategy was sharp and real for everyone inside of the company, all the brand behavior started to roll out as stationary material.",
    overlay: 1,
    component: (props) => <HowDoYouChew {...props} />,
  },

  {
    id: 3,
    title: "Toyota Wishgiver",
    slug: "toyota",
    src: '/assets/img/project/toyota/corolla.png',
    banner: "/assets/img/project/toyota/corolla.png",
    thumb: '/assets/img/project/toyota/thumb.png',
    type: "Website",
    category: ["Web"],
    description:
      "Once the brand strategy was sharp and real for everyone inside of the company, all the brand behavior started to roll out as stationary material.",
    overlay: 1,
    component: (props) => <ToyotaWishGiver {...props} />,
  },

  {
    id: 4,
    title: "Flavour Vote",
    slug: "flavour-vote",
    src: "/assets/img/project/flavour-vote/header3.jpeg",
    banner: "/assets/img/project/flavour-vote/header3.jpeg",
    thumb: '/assets/img/project/flavour-vote/thumb.png',
    type: "Website",
    category: ["Web"],
    description:
      "Once the brand strategy was sharp and real for everyone inside of the company, all the brand behavior started to roll out as stationary material.",
    overlay: 1,
    component: (props) => <FlavorVote {...props} />,
  },
  {
    id: 5,
    title: "The Annex Hotel",
    slug: "the-annex",
    src: "/assets/img/project/annex/thumb.png",
    banner: "/assets/img/project/annex/thumb.png",
    thumb: '/assets/img/project/annex/thumb.png',
    category: ["Web"],
    type: "Website",
    description:
      "Sometimes, we need to check the time, wondering when our work or meeting will finish, without getting caught by others.",
    overlay: 1,
    component: (props) => <Annex {...props} />,
  },
  {
    id: 6,
    title: "trickl +",
    slug: "trickl",
    src: "/assets/img/project/trickl/thumb.png",
    banner: "/assets/img/project/trickl/thumb.png",
    thumb: '/assets/img/project/trickl/thumb.png',
    category: ["Mobile"],
    type: "Mobile App",
    description:
      "Cal was first. The first public university in the great state of California. They are the pioneers. They are the trailblazers who started it all.",
    overlay: 1,

    component: (props) => <Trickl {...props} />,
  },
  {
    id: 7,
    title: "Beacon Medical",
    slug: "beacon-medical",
    src: "/assets/img/project/beacon/banner5.png",
    banner: "/assets/img/project/beacon/banner5.png",
    thumb: '/assets/img/project/beacon/thumb.png',
    category: ["Web"],
    type: "Website & Mobile app",
    description:
      "Sometimes, we need to check the time, wondering when our work or meeting will finish, without getting caught by others.",
    overlay: 0,
    component: (props) => <BeaconMedical {...props} />,
  },
  {
    id: 8,
    title: "Salus Global",
    slug: "salus",
    src: "/assets/img/project/salus/salus1.png",
    banner: "/assets/img/project/salus/salus1.png",
    thumb: '/assets/img/project/salus/thumb.png',
    category: ["Web"],
    type: "Website",
    description:
      "Sometimes, we need to check the time, wondering when our work or meeting will finish, without getting caught by others.",
    overlay: 0,
    component: (props) => <Salus {...props} />,
  },

];

export const getPortfolioData = () => data;

export const getPortfolioItem = (value, whereName = "id") => {
  return data.find((item) => {
    if (item[whereName] === value) return item;
    return null;
  });
};
export const getPortfolioLink = (item) => {
  if (item) return item.slug && "/portfolio/" + item.slug;

  return "";
};
